import { propertyActionService } from '@/services/api/propertyAction.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { propertyActionModel } from '@/models/api/propertyAction.model';
import { propertyActionStatisticSummaryModel } from '@/models/api/propertyActionStatisticSummary.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    statisticSummary: [],
    status: {
        list: true,
        detail: true,
        save: true,
        statisticSummary: true,
    },
};

export const PROPERTY_ACTION_MODULE = "api/propertyAction";

// ACTIONS
export const GET_ALL_PROPERTY_ACTION = 'getAllPropertyAction';
export const GET_PROPERTY_ACTION_STATISTIC_SUMMARY = 'getPropertyActionStatisticSummary';
export const CREATE_PROPERTY_ACTION = 'createPropertyAction';
export const GET_PROPERTY_ACTION = 'getPropertyAction';
export const UPDATE_PROPERTY_ACTION = 'updatePropertyAction';
export const UPDATE_PROPERTY_ACTION_STATUS = 'updatePropertyActionStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_PROPERTY_ACTION_SUCCESS = "allPropertyActionSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_PROPERTY_ACTION_SUCCESS = "getPropertyActionSuccess";
const PROPERTY_ACTION_STATISTIC_SUMMARY_SUCCESS = "propertyActionStatisticSummarySuccess";

export const actions = {
    [GET_PROPERTY_ACTION_STATISTIC_SUMMARY]({commit}) {
        commit(REQUESTING, 'statisticSummary');
        return propertyActionService
            .statisticSummary()
            .then((result) => {
                commit(PROPERTY_ACTION_STATISTIC_SUMMARY_SUCCESS, result);
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_ALL_PROPERTY_ACTION]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        propertyActionService
            .getAll(filter)
            .then((result) => {
                commit(ALL_PROPERTY_ACTION_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_PROPERTY_ACTION]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return propertyActionService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_ACTION, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_PROPERTY_ACTION]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return propertyActionService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_PROPERTY_ACTION_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_PROPERTY_ACTION]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return propertyActionService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_ACTION, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_PROPERTY_ACTION_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return propertyActionService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_ACTION, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [PROPERTY_ACTION_STATISTIC_SUMMARY_SUCCESS](state, data) {
        state.statisticSummary = data.success ? (data.data || []).map(item => propertyActionStatisticSummaryModel(item)) : [];
    },
    [ALL_PROPERTY_ACTION_SUCCESS](state, {data}) {
        let propertyActionList = data.data || [];
        state.list.data = propertyActionList;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = propertyActionList.map(item => propertyActionModel(item));
        }
    },
    [GET_PROPERTY_ACTION_SUCCESS](state, data) {
        state.details = propertyActionModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
            statisticSummary: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
            statisticSummary: true,
        };
    },
};
